import React from 'react'
import './HelpAndSupport.css'

export default function HelpAndSupport() {
  return (
    <div>
      HelpAndSupport
    </div>
  )
}
